<template>
    <div class="flex flex-wrap gap-2 items-center">
        <div class="flex flex-wrap gap-2 items-center" v-if="inspection.signatures && inspection.signatures.length > 0">
            <button @click.prevent="toggleSignaturesModal()" v-for="signature in uniqueSignaturesByGroup">
                <badge :class="setBadgeClass(signature)" :title="setTitle(signature)"
                       :key="signature.id">
                    {{ signature.signatory_group | titlecase }}
                </badge>
            </button>
        </div>
        <div v-else class="flex items-center">
            <!-- Empty signature -->
            <badge :class="setBadgeClass({signatory_group: 'none'})">
                {{ setTitle({signatory_group: "none"}) }}
            </badge>
        </div>

        <inspection-signatures-list-modal
            v-if="showSignaturesModal"
            :inspection="inspection"
            @signature-deleted="deleteSignature"
            @close="toggleSignaturesModal()">
        </inspection-signatures-list-modal>
    </div>
</template>

<script>
import InspectionSignaturesListModal from "./InspectionSignaturesListModal.vue";
import SignaturesListMixin from "../../mixins/inspection-signatures-list-mixin";

export default {
    name: "InspectionSignaturesList",

    components: {InspectionSignaturesListModal},

    mixins: [SignaturesListMixin],

    props: {
        iconClass: {
            type: String,
            required: false,
            default: "w-8 h-8",
        },
        inspection: {
            type: Object,
            required: false,
        },
    },

    data () {
        return {
            showSignaturesModal: false,
        };
    },

    computed: {
        uniqueSignaturesByGroup () {
            // We use this computed function to only show one signature per group in the list.
            // When opening the signatures we still see all the signatures
            return _.uniqBy(this.inspection.signatures, 'signatory_group');
        },
    },

    methods: {
        toggleSignaturesModal () {
            this.showSignaturesModal = !this.showSignaturesModal;
        },
    },
};
</script>